import { render, staticRenderFns } from "./AiChatDock.vue?vue&type=template&id=2d1ca83a&lang=pug"
import script from "./AiChatDock.vue?vue&type=script&lang=js"
export * from "./AiChatDock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports